import * as React from "react";

export enum Interaction {
  MouseEnter = "MOUSE_ENTER",
  MouseOut = "MOUSE_OUT",
  FocusIn = "FOCUS_IN",
  FocusOut = "FOCUS_OUT",
}

type UserInteractionCallback = (action: Interaction) => void;

export default function useUserInteraction(callback: UserInteractionCallback) {
  const elementRef = React.useRef<HTMLElement>(null);
  const handleFocusChange: React.FocusEventHandler<HTMLElement> =
    React.useCallback(
      (event) => {
        const interaction =
          event.type === "blur" ? Interaction.FocusOut : Interaction.FocusIn;
        const currentTarget = event.currentTarget as HTMLElement | null;
        const relatedTarget = event.relatedTarget as HTMLElement | null;

        if (!currentTarget?.contains(relatedTarget)) {
          callback(interaction);
        }
      },
      [callback]
    );

  const interactionProps = React.useMemo(
    () => ({
      ref: elementRef,
      onMouseEnter: () => callback(Interaction.MouseEnter),
      onMouseOut: () => callback(Interaction.MouseOut),
      onFocus: handleFocusChange,
      onBlur: handleFocusChange,
    }),
    [callback, handleFocusChange]
  );

  return {
    interactionProps,
  };
}
